import { useState } from 'react';

export type AllocationSelection = {
  selectedIds: ReadonlySet<number>;
  count: number;
  isSelected: (id: number) => boolean;
  toggle: (id: number) => void;
  setMany: (ids: number[], selected: boolean) => void;
  clear: () => void;
};

export function useAllocationSelection(resetKey: string): AllocationSelection {
  const [selectedIds, setSelectedIds] = useState<ReadonlySet<number>>(() => new Set());
  const [seenKey, setSeenKey] = useState(resetKey);

  if (seenKey !== resetKey) {
    setSeenKey(resetKey);
    setSelectedIds(new Set());
  }

  return {
    selectedIds,
    count: selectedIds.size,
    isSelected: (id) => selectedIds.has(id),
    toggle: (id) =>
      setSelectedIds((current) => {
        const next = new Set(current);
        if (!next.delete(id)) next.add(id);
        return next;
      }),
    setMany: (ids, selected) =>
      setSelectedIds((current) => {
        const next = new Set(current);
        for (const id of ids) {
          if (selected) next.add(id);
          else next.delete(id);
        }
        return next;
      }),
    clear: () => setSelectedIds(new Set()),
  };
}
